import PosActions from '../../../actions/PosActions';
import PosCartActions from '../../../actions/PosCartActions';
import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';
import { endPoints as PosEndPoints } from '../../../constants/PosConstants';
import AddByTabMessage from '../notification/AddByTabMessage.react';
import AjaxPromises from '../../../utils/AjaxPromises';
import PosCartStore from '../../../stores/PosCartStore';
import NotificationActions from '../../../actions/NotificationActions';
import { endPoints as UserEndPoints } from '../../../constants/UserConstants';

class PosHeader extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading         : false,
            disableSearch   : UserStore.getState().selectedLocation.ManagerSearchFlag,
            addByTabMessage : [],
        };

        this.search = this.search.bind(this);
        this.scan = this.scan.bind(this);
        this.addByTab = this.addByTab.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.unlock = this.unlock.bind(this);
        this.unlockSearchDisabled = this.unlockSearchDisabled.bind(this);
    }

    unlock() {
        let self = this;
        if (this.state.loading) {
            return;
        }

        this.setState({ loading : true }, () => {
            AjaxPromises.POST(UserEndPoints.CHECK_PIN_NUMBER, UserStore.getApiData({
                PinCode : this.props.searchText,
            })).then(res => {
                self.setState({ loading : false }, () => {
                    if (res.Data[0].MgrPermission === true) {
                        this.setState({ disableSearch : false});
                        this.props.updateSearchText('');
                    } else {
                        NotificationActions.error('Invalid PIN');
                    }
                });
            });
        });
    }

    addByTab() {
        let self = this;

        const query = this.props.searchText;
        const location = UserStore.getState().selectedLocation;

        if (query.length === 0) {
            return;
        }

        let formData            = UserStore.getApiData();
        if (location.Enter3or4of11) {
            let arr = query.split(',');

            if (arr.length < 1) {
                return;
            }

            for (let i=0; i<arr.length; i++) {
                arr[i] = arr[i].replace(/ /g,'');
            }

            for (let i=0; i<arr.length; i++) {
                arr[i] = arr[i].split('x');
            }

            for (let i = arr.length - 1; i >= 0; i--) {
                if (arr[i].length > 2) {
                    arr.splice(i, 1);
                }

                else if (arr[i][(arr[i].length -1)].length < 3 || arr[i][(arr[i].length -1)].length > 5) {
                    arr.splice(i, 1);
                }
            }

            for (let i=0; i<arr.length; i++) {
                if (arr[i].length === 1) {
                    arr[i] = ['1', arr[i]];
                }
            }

            let add = [];
            for (let i=0; i<arr.length; i++) {
                for (let j=0; j<arr[i][0]; j++) {
                    add.push(arr[i][1]);
                }
            }

            const hist = add.reduce( function (prev, item) {
                if ( item in prev ) {
                    prev[item] ++;
                } else {
                    prev[item] = 1;
                }
                return prev;
            }, {} );

            let addArr = [];
            for(let i in hist) {
                addArr.push([i, hist [i]]);
            }

            this.props.updateSearchText('');

            for (let i=0; i<addArr.length; i++) {
                if (location.Enter3or4of11) {
                    while (addArr[i][0].length < 11) {
                        addArr[i][0] = '0'+addArr[i][0];
                    }
                }
                
                self.addToCart(addArr[i][0], addArr[i][1]);
            }
        } else {
            this.props.updateSearchText('');
            let formData = UserStore.getApiData();
            formData.SearchString = query;

            AjaxPromises.POST(PosEndPoints.POS_PRODUCT_SEARCH, formData).then(res => {
                let match = false;
                if (res.Result === true) {
                    for (let i=0; i<res.Data.length; i++) {
                        if (res.Data[i].SerialNo === query) {
                            PosCartActions.addItemToCart(res.Data[i], self.props.guest, 1);
                            match = true;
                        }
                    }
                }

                if (!match || res.Result === false) {
                    let arr = self.state.addByTabMessage;

                    arr.push({ serialNo : query, found : false, qty : 0, item : false });
                    self.setState({ addByTabMessage : arr });
                }
            });
        }

        setTimeout(() => {
            $('#product-search').focus();
        }, 100);
    }

    addToCart(query, qty) {
        let self = this;

        let formData = UserStore.getApiData();
        formData.SearchString = query;
        AjaxPromises.POST(PosEndPoints.POS_PRODUCT_SEARCH,
            formData).then(res => {
                let arr = self.state.addByTabMessage;

                if (res.Result === false || res.Data === null || res.Data.length !== 1) {
                    arr.push({ serialNo : query, found : false, qty : 0, item : false });
                    self.setState({ addByTabMessage : arr });
                } else if (res.Data[0].TotalAvailable < qty) {
                    arr.push({ serialNo : query, found : true, qty : res.Data[0].TotalAvailable, item : res.Data[0] });
                    self.setState({ addByTabMessage : arr });
                } else {
                    PosCartActions.addItemToCart(res.Data[0], self.props.guest, qty);
                }
            }
        );
    }

    search(page, text) {
        PosActions.productSearch(UserStore.getApiData(), this.props.guest.Guest_id);
        this.props.onSearch(page, text);
    }

    scan(barcode) {
        if (UserStore.getState().selectedLocation.PackageItemIds) {
            const cart = PosCartStore.getState().cart;
            for (let i=0; i<cart.length; i++) {
                const item = cart[i];
                if (item.PackageItemId == barcode) {
                    PosCartActions.removeItemFromCart(item, this.props.guest, 1, true);
                    return;
                }
            }
        }

        const formData = UserStore.getApiData({
            SerialNumber : barcode.toString(),
            CustomerId: this.props.guest.Guest_id,
        });

        AjaxPromises.POST(PosEndPoints.SCAN_PRODUCT, formData)
            .then((res) => {
                if (!res.Result || !res.Data || res.Data.length !== 1) {
                    NotificationActions.addNotification({
                        type : 'alert',
                        body : 'Could not find product'
                    });
                } else {
                    if (res.Data[0].ProductType === 'Qty') {
                        PosCartActions.addItemToCart(res.Data[0], this.props.guest, 1);
                    } else {
                        PopupActions.addBulk(this.props.guest, res.Data[0]);
                    }
                }
            });
    }

    unlockSearchDisabled() {
        return !this.props.searchText || this.state.loading;
    }

    render() {
        let self = this,
            guest = this.props.guest,
            disabled = this.state.disableSearch,
            location = UserStore.getState().selectedLocation;
        return ([
            <div className='pos-header__search'>

                <input
                    type={disabled ? 'password' : 'text'}
                    className='pos-header__search--input'
                    id='product-search'
                    value={this.props.searchText}
                    placeholder={disabled ? 'PIN' : 'Product search'}
                    onFocus={() => this.props.onSearchFocus(true)}
                    onBlur={() => this.props.onSearchFocus(false)}
                    onChange={e => {
                        this.props.updateSearchText(e.target.value);
                    }}
                    onKeyDown={e => {
                        const keyCode = e.keyCode || e.which;

                        if (keyCode == 9) {
                            e.preventDefault();
                            if (location.Enter3or4of11 || location.SearchFullSerialNo) {
                                self.addByTab();
                            } else if (location.PackageItemIds) {
                                self.scan(this.props.searchText);
                            }
                        } else if (keyCode === 13) {
                            if (disabled) {
                                self.unlock();
                            } else {
                                self.search(null, this.props.searchText);
                            }
                            
                        }
                    }}
                />

                { !disabled ? 
                    <div>
                        <button
                            className='pos-header__search--product'
                            onClick={() => { this.search('productSearch', ''); }}>

                            { this.state.loading ? 'Loading' : 'Product' }
                        </button>
                        <button
                            className='pos-header__search--category'
                            onClick={() => { this.search('categorySearch', ''); }}>

                            { this.state.loading ? 'Loading' : 'Category' }
                        </button>
                        <button
                            className='pos-header__search--strain'
                            onClick={() => { this.search('strainSearch', ''); }}>

                            { this.state.loading ? 'Loading' : 'Strain' }
                        </button>
                    </div>
                    :
                    <button
                    className={`pos-header__search--unlock ${this.unlockSearchDisabled() ? 'btn-green__disabled' : ''}`}
                    onClick={this.unlock}
                    disabled={this.unlockSearchDisabled()}>
                        { this.state.loading ? 'Loading' : 'Unlock Search' }
                    </button>
                }
            </div>,


            ( this.state.addByTabMessage.length > 0 &&
                <AddByTabMessage
                    guest={guest}
                    messageArr={this.state.addByTabMessage}
                    onClose={() => { this.setState({ addByTabMessage : [] }); }} />
            )
        ]);
    }
}

export default PosHeader;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/header/PosHeaderSearch.react.jsx